import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  public scrollSidebarSource = new Subject<any>();
  public closeSidebarSource = new Subject<void>();
  public openSidebarSource = new Subject<any>();
  public reloadDatasetSource = new Subject<void>();

  public scrollSidebarCalled$ = this.scrollSidebarSource.asObservable();
  public closeSidebarCalled$ = this.closeSidebarSource.asObservable();
  public openSidebarCalled$ = this.openSidebarSource.asObservable();
  public reloadDatasetCalled$ = this.reloadDatasetSource.asObservable();

  constructor() {}

  public scrollSidebar(isScrolling: boolean) {
    this.scrollSidebarSource.next(isScrolling);
  }

  public closeSidebar() {
    this.closeSidebarSource.next();
  }

  public openSidebar(type?: string, id?: string, tab?: number) {
    this.openSidebarSource.next({
      id,
      type,
      tab
    });
  }
}
